export const store = {
    state: {
      username: '',
      access_token: '',
      lastCartId: '',
    },
    setLoginInfo(newToken, newUserName) {
      this.state.access_token = newToken;
      localStorage.access_token = newToken;
      this.state.username = newUserName;
      localStorage.username = newUserName;
    },
    resetLoginInfo() {
      this.state.username = '';
      localStorage.username = '';
      this.state.access_token = '';
      localStorage.access_token = '';
    },
    getToken() {
      return localStorage.access_token;
    },
    storeCartId(newCartid) {
      this.state.lastCartId = newCartid;
    },
    getCartId() {
      return this.state.lastCartId;
    },
  };